import { Injectable, InjectionToken, Optional, Inject } from '@angular/core';
import { Observable, Scheduler, of, empty } from 'rxjs';
import { async } from 'rxjs/internal/scheduler/async';
import { map, switchMap, debounceTime, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as outstandingDebtActions from '../actions/outstanding-debt';
import * as propertyDetailsActions from '../../properties/actions/property-details';
import { OutstandingDebtService } from '../services/outstanding-debt.service';
import { OutstandingDebt } from '../models/outstanding-debt';

export const SEARCH_DEBOUNCE = new InjectionToken<number>('Search Debounce');
export const SEARCH_SCHEDULER = new InjectionToken<Scheduler>('Search Scheduler');

@Injectable()
export class OutstandingDebtEffects {

  
  triggerGet$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<propertyDetailsActions.Get>(propertyDetailsActions.GET),
    map(action => {
      return new outstandingDebtActions.Get(action.payload);
    })
  ));

  
  get$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<outstandingDebtActions.Get>(outstandingDebtActions.GET),
    debounceTime(this.debounce, this.scheduler || async),
    switchMap(action => {
      if (action.propertyRef === undefined) {
        return empty();
      }
      return this.outstandingDebtService.getOutstandingDebtByPropertyRef(action.propertyRef).pipe(
        map((outstandingDebt: OutstandingDebt) => new outstandingDebtActions.GetComplete(outstandingDebt)),
        catchError(err => of(new outstandingDebtActions.GetError(err)))
      );
    })));

  constructor(
    private actions$: Actions,
    private outstandingDebtService: OutstandingDebtService,
    @Optional()
    @Inject(SEARCH_DEBOUNCE)
    private debounce: number = 300,
    @Optional()
    @Inject(SEARCH_SCHEDULER)
    private scheduler: Scheduler) {
  }

}

